var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTripBold = function SvgTripBold(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.31 5.698a.857.857 0 0 0 .673-1.009.857.857 0 0 0-1.008-.672l-7.128 1.425-.032.007-7.126 1.425a.857.857 0 0 0 .336 1.68l6.118-1.223v2.955H7.714a2 2 0 0 0-2 2v5.143a2 2 0 0 0 2 2h8.572a2 2 0 0 0 2-2v-5.143a2 2 0 0 0-2-2h-3.429V6.989zM11.144 12H7.714a.286.286 0 0 0-.285.286v2.285h3.714zm5.428 2.571h-3.714V12h3.429a.286.286 0 0 1 .285.286z",
    clipRule: "evenodd"
  })));
};
export { SvgTripBold as ReactComponent };
export default __webpack_public_path__ + "static/media/tripBold.8aec77913f50d2b82936412fb692a318.svg";